import React, { Component } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Loader, TypeaheadMultiSelectField, Icon } from '@jutro/components';
import { isCapabilityEnabled } from 'gw-portals-config-js';

import { Link, withRouter } from 'react-router-dom';
import { GatewayClaimService } from 'gw-capability-ri-claim';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { DatatableUtil } from 'gw-portals-util-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import styles from './ClaimsListing.module.scss';
import metadata from './ClaimsListing.metadata.json5';
import messages from '../../Claims.messages';
import { ButtonLink } from '@jutro/router';

const { gatewayParamConfig = {} } = appConfig;

class ClaimsListing extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        isLoggedIn: PropTypes.bool,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,
        intl: PropTypes.func.isRequired,
    };

    state = {
        policyResponse: {},
        isLoading: true,
        currentView: 'recent',
        selectedHeaderContent: messages.recentlyReportedHeader,
        searchClaimKeyword: undefined,
        claimsData: {},
        recentClaimsData: [],
        openClaimsData: [],
        closedClaimsData: []
    };

    componentDidMount() {
        this.loadInitialData();
    }

    loadInitialData = async () => {
        const {
            location: { state: redirectPath, pathname }
        } = this.props;
        const routePath = pathname && (pathname.trim().split('/') || []);
        const selectedPageFromPath = routePath[routePath.length - 1];
        const activeTile = selectedPageFromPath || redirectPath || 'recent';
        
        this.setState({ currentView: activeTile, isLoading: true });
        
        // Load data for the active tab
        if (activeTile === 'recent') {
            await this.loadRecentClaims();
        } else if (activeTile === 'open') {
            await this.loadOpenClaims();
        } else if (activeTile === 'closed') {
            await this.loadClosedClaims();
        }
        
        this.setState({ isLoading: false });
    }

    processResponseData = (responseData) => {
        const { intl } = this.props;
        if (!_.isEmpty(responseData)) {
            return responseData.map((claimInfo) => {
                const claims = {
                    type: claimInfo.isPersonalAccount ? 'Personal' : 'Commercial',
                    product: claimInfo.product,
                    account: claimInfo.insuredName,
                    claimNumber: claimInfo.claimNumber,
                    dateOfLoss: intl.formatDate(new Date(claimInfo.dateOfLoss), { year: 'numeric', month: 'short', day: 'numeric' }),
                    status: claimInfo.status,
                    paid: claimInfo.amountPaidWithExpenses,
                    netIncurred: claimInfo.totalIncurredNet,
                    policyNumber: claimInfo.policyNumber,
                    accountNumber: claimInfo.accountNumber,
                    dateOfInjury: claimInfo.lossDate,
                    claimantName: claimInfo.claimantName,
                    dateReported: intl.formatDate(new Date(claimInfo.reportedDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                    reportedDate: new Date(claimInfo.reportedDate).getTime(),
                    isDraft: claimInfo.status === 'draft',
                    accountNumber: claimInfo.accountNumber,
                    accountIsPersonal: false, // claim.isPersonalAccount,
                    accountName: '', // claim.insuredName,
                    amountPaidWithExpenses: claimInfo.amountPaidWithExpenses,
                    totalIncurredWithExpenses: claimInfo.totalIncurredWithExpenses,
                    insuredName: claimInfo.insuredName,
                    injuryDesc: claimInfo.injuryDesc,
                    injuryBodyPart: claimInfo.injuryBodyPart,
                    accidentDesc: claimInfo.accidentDesc,
                    jobDesc: claimInfo.jobDesc,
                    accidentLocation: claimInfo.accidentLocation,
                    isPcPolicyTerm_Ext: claimInfo.isPcPolicyTerm_Ext
                };
                return claims;
            });
        }
        return [];
    };

    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            product: translator(messages.product),
            dateOfLoss: translator(messages.dateOfLoss),
            status: translator(messages.status)
        };

        return (
            <span title={toolTipMessage[property]}>
                {item[property]}
            </span>
        );
    };

    getCurrencyCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            paid: translator(messages.totalPayments),
            netIncurred: translator(messages.totalIncurrednet)
        };
        return (
            <span
                title={toolTipMessage[property]}
                className={styles.riCurrencyField}
            >
                <CurrencyField
                    id={`claimsCurrency_${index}`}
                    value={item[property]}
                    datatype="object"
                    readOnly
                    hideLabel
                />
            </span>
        );
    };

    getLink = (item, index, { id: property }) => {
        const { currentView } = this.state; // Bug list 27.
        const translator = this.context;
        let toolTipMessage = translator(messages.claimNumber);
        if (property === 'policyNumber') {
            toolTipMessage = translator(messages.policyNumber);
            return (
                <Link
                    to={`/ri-policies/${item[property]}/summary`}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }
        if (
            item.status
            === translator({
                id: 'typekey.ClaimState.draft',
                defaultMessage: 'Draft'
            })
        ) {
            const redirectpath = {
                pathname: '/fnol-select-policy',
                state: {
                    claimNumber: item[property],
                    redirectPath: '/ri-claims',
                    claimStatus: item.status
                }
            };

            return (
                <Link
                    to={redirectpath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }
        const redirectpath = {
            pathname: `/ri-claims-details/${item[property]}`,
            state: {
                claimNumber: item[property],
                redirectPath: `/ri-claims/tile/${currentView}`, // Bug list 27.
                claimStatus: item.status
            }
        };
        return (
            <Link to={redirectpath} className={styles.gwClaimsLinkContent} title={toolTipMessage}>
                {item[property]}
            </Link>
        );
    };


    getFileClaimBotton = (item, index, { id: property }) => {
        const { currentView } = this.state; // Bug list 27.
        const translator = this.context;
        let toolTipMessage = translator(messages.claimNumber);
        
        const redirectpath = {
                pathname: '/fnol-select-policy',
                state: {
                    claimNumber: item[property],
                    redirectPath: '/ri-claims',
                    claimStatus: item.status
                }
            };

            return (
                <Link
                    to={redirectpath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }

    getFormattedDateField = (item, index, property) => {
        const translator = this.context;
        return this.getFormattedDate(item[property.id]);
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        return intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
    };
    //FB 21425 -------
    fileUploadLink = (item, index, { id: property }) => {
        const { authHeader, isLoading, currentView } = this.state;
        const claimNumber = item["claimNumber"] === null ? item[property] : item["claimNumber"];

        const redirectpath = {
            pathname: `/ri-fileupload`,
            state: {
                clmNo: claimNumber,
                polNo: item["policyNumber"],
                dateOfLoss: item["dateOfInjury"],
                redirectPath: `/ri-claims/tile/${currentView}`,
            }
        };  
        return (
            <ButtonLink to={redirectpath} className={styles.ri__ActionColumn__continueButton}>
                Upload Docs
            </ButtonLink>
        );
    };
    //------- FB 21425 
    loadRecentClaims = async () => {
        const { authHeader } = this.props;
        const paramProducerCode = null;
        
        try {
            const response = _.isNull(paramProducerCode)
                ? await GatewayClaimService.getClaimsForCurrentUser(
                    [gatewayParamConfig.claimsCreatedInLastXDays, null, [{PropertyName: 'Status', PropertyValue: 'All'} ]],
                    authHeader
                )
                : await GatewayClaimService.getOpenClaimsForProducerCode(
                    [gatewayParamConfig.claimsCreatedInLastXDays, null, paramProducerCode],
                    authHeader
                );
                
            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(data, (row) => row.reportedDate, ['desc']);
            
            this.setState({
                recentClaimsData: sortedData,
                selectedHeaderContent: messages.recentlyReportedHeader
            });
        } catch (error) {
            console.error('Error loading recent claims:', error);
            this.setState({ recentClaimsData: [] });
        }
    }




    loadOpenClaims = async () => {
        const { authHeader } = this.props;
        const paramProducerCode = null;
        
        try {
            const response = _.isNull(paramProducerCode)
                ? await GatewayClaimService.getOpenClaimsForCurrentUser(
                    [null, null, paramProducerCode],
                    authHeader
                )
                : await GatewayClaimService.getOpenClaimsForProducerCode(
                    [null, null, paramProducerCode],
                    authHeader
                );
                
            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(data, (row) => row.dateOfInjury, ['desc']);
            
            this.setState({
                openClaimsData: sortedData,
                selectedHeaderContent: messages.openClaims
            });
        } catch (error) {
            console.error('Error loading open claims:', error);
            this.setState({ openClaimsData: [] });
        }
    };

    loadClosedClaims = async () => {
        const { authHeader } = this.props;
        const paramProducerCode = null;
        
        try {
            const response = _.isNull(paramProducerCode)
                ? await GatewayClaimService.getClosedClaimsForCurrentUser(
                    [null, null, paramProducerCode],
                    authHeader
                )
                : await GatewayClaimService.getClosedClaimsForProducerCode(
                    [null, null, paramProducerCode],
                    authHeader
                );
                
            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(data, (row) => row.dateOfInjury, ['desc']);
            
            this.setState({
                closedClaimsData: sortedData,
                selectedHeaderContent: messages.closedClaims
            });
        } catch (error) {
            console.error('Error loading closed claims:', error);
            this.setState({ closedClaimsData: [] });
        }
    };

    handleTabChange = async (newView) => {
        const { recentClaimsData, openClaimsData, closedClaimsData } = this.state;
        
        this.setState({ currentView: newView });
        
        // Only load data if not already cached
        if (newView === 'recent' && recentClaimsData.length === 0) {
            this.setState({ isLoading: true });
            await this.loadRecentClaims();
            this.setState({ isLoading: false });
        } else if (newView === 'open' && openClaimsData.length === 0) {
            this.setState({ isLoading: true });
            await this.loadOpenClaims();
            this.setState({ isLoading: false });
        } else if (newView === 'closed' && closedClaimsData.length === 0) {
            this.setState({ isLoading: true });
            await this.loadClosedClaims();
            this.setState({ isLoading: false });
        } else {
            // Data already cached, just update the header
            if (newView === 'recent') {
                this.setState({ selectedHeaderContent: messages.recentlyReportedHeader });
            } else if (newView === 'open') {
                this.setState({ selectedHeaderContent: messages.openClaims });
            } else if (newView === 'closed') {
                this.setState({ selectedHeaderContent: messages.closedClaims });
            }
        }
    };

    handleSearchValueChange = (value) => {
        const { transactionResponse } = this.state;
        this.setState({ searchClaimKeyword: value });
        this.getMappedTransactionData(transactionResponse, {
            searchClaimKeyword: value
        });
    };

    // getSearchFilterValues = (transactionData, keyword) => {
    //     const lowerCaseFilterValue = keyword.toLocaleLowerCase();
    //     return _.filter(transactionData, (res) => {
    //         return Object.keys(res).some(
    //             (key) => typeof res[key] === 'string'
    //                 && res[key].toLocaleLowerCase().includes(lowerCaseFilterValue)
    //         );
    //     });
    // };

    getMappedClaimsData = (policyTransactionResponse, filter) => {
        const selectedStatus = _.get(filter, 'selectedTransactionStatus');
        const searchKeyword = _.get(filter, 'searchTransactionKeyword');
        const transactionData = _.cloneDeep(policyTransactionResponse);
        const { intl } = this.props;

        if (searchKeyword) {
            policyTransactionData = this.getSearchFilterValues(
                policyTransactionData,
                searchKeyword
            );
        }
        this.setState({
            policyTransactionData
        });
    }

    render() {
        const {
            policyResponse,
            isLoading,
            currentView,
            selectedHeaderContent,
            searchClaimKeyword,
            claimsData,
            recentClaimsData,
            openClaimsData,
            closedClaimsData
        } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }
        const translator = this.context;
        const tableKey = currentView;
        
        // Get data for the current view
        let currentData = [];
        if (currentView === 'recent') {
            currentData = recentClaimsData;
        } else if (currentView === 'open') {
            currentData = openClaimsData;
        } else if (currentView === 'closed') {
            currentData = closedClaimsData;
        }

        const overrides = {
            recentlyViewedTableGrid: {
                data: currentData,
                key: tableKey,
                defaultSorted: [
                    { id: 'dateOfInjuryColumnTitle', desc: false },
                    { id: 'paidColumnTitle', desc: true },
                    { id: 'netIncurredColumnTitle', desc: true }
                ]
            },
            [currentView]: {
                active: true
            },
            recentlyViewedId: {
                content: translator(selectedHeaderContent)
            },
            searchFilter: {
                value: searchClaimKeyword
            }
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
                getCell: this.getCell,
                getCurrencyCell: this.getCurrencyCell,
                getLink: this.getLink,
                sortCurrency: DatatableUtil.sortCurrency,
                sortString: DatatableUtil.sortString,
                sortDate: DatatableUtil.sortDate,
                getFormattedDate: this.getFormattedDateField,
                handleSearchValueChange: this.handleSearchValueChange,
                fileUploadLink: this.fileUploadLink //FB 21425
            },
            resolveClassNameMap: styles
        };

        const policyDetailsData = {
            policyResponse: policyResponse,
            getUpdateCountInfo: this.updateCountInfo,
        };
        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyResponse}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }
}

export default withRouter(withIntl(withAuthenticationContext(ClaimsListing)));
